/* istanbul ignore file */
interface TrashIconProps {
    size?: number;
}

export const TrashIcon = ({ size: _size = 20 }: TrashIconProps) => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 3.9987H3.83333M3.83333 3.9987H14.5M3.83333 3.9987V13.332C3.83333 13.6857 3.97381 14.0248 4.22386 14.2748C4.47391 14.5249 4.81304 14.6654 5.16667 14.6654H11.8333C12.187 14.6654 12.5261 14.5249 12.7761 14.2748C13.0262 14.0248 13.1667 13.6857 13.1667 13.332V3.9987H3.83333ZM5.83333 3.9987V2.66536C5.83333 2.31174 5.97381 1.9726 6.22386 1.72256C6.47391 1.47251 6.81304 1.33203 7.16667 1.33203H9.83333C10.187 1.33203 10.5261 1.47251 10.7761 1.72256C11.0262 1.9726 11.1667 2.31174 11.1667 2.66536V3.9987M7.16667 7.33203V11.332M9.83333 7.33203V11.332"
                stroke="#98A2B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
